type TFn = (key: string, opts?: { defaultValue: string }) => string;

/** Chrome space names only — user content stays as data. */
const SPACE_KEYS: Record<string, [string, string]> = {
  Workspace: ["tasks.sidebar.workspace", "Workspace"],
  Home: ["tasks.sidebar.home", "Home"],
  Inbox: ["tasks.sidebar.inbox", "Inbox"],
  Replies: ["tasks.sidebar.replies", "Replies"],
  "Assigned Comments": ["tasks.sidebar.assignedComments", "Assigned Comments"],
  "My Tasks": ["tasks.sidebar.myTasks", "My Tasks"],
  Favorites: ["tasks.sidebar.favorites", "Favorites"],
  Spaces: ["tasks.sidebar.spaces", "Spaces"],
  "All Tasks": ["tasks.sidebar.allTasks", "All Tasks"],
  Hubs: ["tasks.sidebar.hubs", "Hubs"],
};

const STATUS_KEYS: Record<string, [string, string]> = {
  "TO DO": ["tasks.status.todo", "TO DO"],
  "IN PROGRESS": ["tasks.status.inProgress", "IN PROGRESS"],
  COMPLETE: ["tasks.status.complete", "COMPLETE"],
};

const PRIORITY_KEYS: Record<string, [string, string]> = {
  Urgent: ["tasks.priority.urgent", "Urgent"],
  High: ["tasks.priority.high", "High"],
  Normal: ["tasks.priority.normal", "Normal"],
  Low: ["tasks.priority.low", "Low"],
};

const DUE_KEYS: Record<string, [string, string]> = {
  Today: ["tasks.due.today", "Today"],
  Tomorrow: ["tasks.due.tomorrow", "Tomorrow"],
  "Next Week": ["tasks.due.nextWeek", "Next Week"],
  "This Week": ["tasks.due.thisWeek", "This Week"],
  Yesterday: ["tasks.due.yesterday", "Yesterday"],
  Overdue: ["tasks.due.overdue", "Overdue"],
  Later: ["tasks.due.later", "Later"],
  "No date": ["tasks.due.noDateShort", "No date"],
  "No Date": ["tasks.due.noDate", "No Date"],
};

const RESOLUTION_KEYS: Record<string, [string, string]> = {
  Unresolved: ["tasks.resolution.unresolved", "Unresolved"],
  Resolved: ["tasks.resolution.resolved", "Resolved"],
  Completed: ["tasks.resolution.completed", "Completed"],
};

function lookup(map: Record<string, [string, string]>, value: string, t: TFn): string {
  const entry = map[value];
  return entry ? t(entry[0], { defaultValue: entry[1] }) : value;
}

export function taskSpaceLabel(name: string, t: TFn): string {
  return lookup(SPACE_KEYS, name, t);
}

export function taskStatusLabel(status: string, t: TFn): string {
  return lookup(STATUS_KEYS, status, t);
}

export function taskPriorityLabel(priority: string, t: TFn): string {
  return lookup(PRIORITY_KEYS, priority, t);
}

export function taskDueLabel(due: string, t: TFn): string {
  return lookup(DUE_KEYS, due, t);
}

export function taskResolutionLabel(resolution: string, t: TFn): string {
  return lookup(RESOLUTION_KEYS, resolution, t);
}
